export default "__VITE_ASSET__BWBnTHH0__"